export const positiveOrZero = (value: number) => Math.max(value, 0);

export const getDefaultRenderIndexes = (
    itemWidth: number,
    columns: number,
    containerRef?: React.RefObject<HTMLDivElement>,
) => {
    const renderIndexes: Array<{ start: number; end: number }> = [];
    const containerElement = containerRef?.current || document.documentElement;

    const minEnd = Math.ceil(containerElement.clientHeight / itemWidth);

    for (let i = 0; i < columns; i++) {
        renderIndexes.push({ start: 0, end: minEnd });
    }

    return renderIndexes;
};

export const getMinHeghtColumnIndex = (columns: number[][]) => {
    let minIndex = 0;
    let minHeight = columns[0][columns[0].length - 1] || 0;

    for (let i = 1; i < columns.length; i++) {
        const currentHeight = columns[i][columns[i].length - 1] || 0;

        if (currentHeight < minHeight) {
            minHeight = currentHeight;
            minIndex = i;
        }
    }

    return minIndex;
};
